// extracted by mini-css-extract-plugin
export default {"triumphCo":"Support_triumphCo__aik-m","support":"Support_support__pIOYt"};